import Cookies from 'js-cookie'
import queryString from 'query-string'
import axios from 'axios'
import rpn from 'request-promise-native'
import firebase from 'firebase'

import firebaseConfig from '../config/firebase/firebaseConfig'

const memberAPIUrl = '/users/members'
const orderAPIUrl = '/storage/members'
const wineAPIUrl = '/cellar-mgts/members'

export default class ApiWrapper {
    constructor(dispatch, failureAction) {
        this.dispatch = dispatch
        this.failureAction = failureAction
    }

    callBackendApi = async (method, url, payload) => {
        // console.log(`callBackendApi ${method} ${url}`)
        let user = await firebase.auth().currentUser
        let token = Cookies.get('token')
        if (user) {
            token = await user.getIdToken()
            Cookies.set('token', token)
        }
        let request = axios.create({
            baseURL: firebaseConfig.API_URL,
            headers: { 'Authorization': token }
        })
        let result
        try {
            switch (method.toUpperCase()) {
                case 'GET':
                    result = await request.get(url)
                    break
                case 'POST':
                    result = await request.post(url, payload)
                    break
                case 'PATCH':
                    result = await request.patch(url, payload)
                    break
                case 'PUT':
                    result = await request.put(url, payload)
                    break
                default:
                    throw new Error('Unknow method')
            }

            if (result.status === 200) {
                let layer1Data = result.data
                return layer1Data.data ? layer1Data.data : layer1Data
            }

            throw new Error(result)
        } catch (error) {
            if (this.failureAction) {
                this.dispatch(this.failureAction(error.response.data))
            }
            throw error
        }
    }

    getMemberInfo = async () => (
        this.callBackendApi('GET', `${memberAPIUrl}/${Cookies.get('memberSha')}`)
    )

    createMember = async (memberSha, email, name) => (
        this.callBackendApi('POST', memberAPIUrl, { memberSha, email, name })
    )

    updateMemberInfo = async (member) => (
        this.callBackendApi('PATCH', `${memberAPIUrl}/${Cookies.get('memberSha')}`, member)
    )

    sendPhoneVerificationCode = async (phone) => (
        this.callBackendApi('POST', `${memberAPIUrl}/${Cookies.get('memberId')}/phone-verification-code`, { phone })
    )

    verifyPhoneNumberVerificationCode = async (phone, verificationCode) => (
        this.callBackendApi('POST', `${memberAPIUrl}/${Cookies.get('memberId')}/verify-phone`, { phone, verificationCode })
    )

    getOrderList = async (query, page, perPage) => (
        this.callBackendApi('GET', `${orderAPIUrl}/${Cookies.get('memberId')}/orders?${queryString.stringify({ page, perPage, ...query })}`)
    )

    getOrderItemsList = async (orderId, page, perPage) => (
        this.callBackendApi('GET', `${orderAPIUrl}/${Cookies.get('memberId')}/orders/${orderId}/items?${queryString.stringify({ page, perPage })}`)
    )

    // filter: {
    //     "country": country code (separated by commas)
    //     "region": region id (separated by commas)
    //     "minValue": minimum wine value
    //     "maxValue": maximum wine value
    //     "color": red / white / rose / others (separated by commas)
    //     "style": still / sparkling / fortified / dessert (separated by commas)
    //     "maxVintage": maximum wine vintage
    //     "minVintage": minimum wine vintage
    //     "isIncludeNV": is wine vintage include NV, 1: yes / 0: no
    //     "volume": wine volume, (separated by commas) (if include 3000 will return the wine volume more than 3000)
    //     "orderBy": update / value / PAL (profit and loss)
    //     "order": DESC / ASC
    //     "page": number of pages
    //     "perPage": number of display items on each page
    // }
    getWineList = async (filter, page, perPage) => (
        this.callBackendApi('GET', `${orderAPIUrl}/${Cookies.get('memberId')}/cw-wines?${queryString.stringify({ page, perPage, ...filter })}`)
    )

    getWinesLatestActivity = async (memberWineIds) => (
        this.callBackendApi('GET', `${orderAPIUrl}/${Cookies.get('memberId')}/member-wines/activities?${queryString.stringify({ memberWineIds }, { arrayFormat: 'comma' })}`)
    )

    getWineData = async (cwWineId, volume) => (
        this.callBackendApi('GET', `${orderAPIUrl}/${Cookies.get('memberId')}/cw-wines/${cwWineId}?${queryString.stringify({ volume })}`)
    )

    getCellarStats = async (cellarId) => (
        this.callBackendApi('GET', `${orderAPIUrl}/${Cookies.get('memberId')}/cellars/${cellarId}/stats`)
    )

    getShippingCartList = async (page, perPage) => (
        this.callBackendApi('GET', `${orderAPIUrl}/${Cookies.get('memberId')}/cart?${queryString.stringify({ page, perPage })}`)
    )

    updateShippingCart = async (memberWineIds) => (
        this.callBackendApi('PUT', `${orderAPIUrl}/${Cookies.get('memberId')}/cart`, { storageOrderItem: [...memberWineIds] })
    )

    getOrderHistoryAddress = async () => (
        this.callBackendApi('GET', `${orderAPIUrl}/${Cookies.get('memberId')}/orders-address`)
    )

    createShippingOrder = async (order) => (
        this.callBackendApi('POST', `${orderAPIUrl}/${Cookies.get('memberId')}/cart-order`, order)
    )

    getOrderInfo = async (orderId) => (
        this.callBackendApi('GET', `${orderAPIUrl}/${Cookies.get('memberId')}/orders/${orderId}`)
    )

    orderCreditCardPayment = async (orderId, data) => (
        this.callBackendApi('POST', `${orderAPIUrl}/${Cookies.get('memberId')}/orders/${orderId}/credit-card-payment`, data)
    )

    updateCreditCardSetting = async (setting) => (
        this.callBackendApi('PUT', `${memberAPIUrl}/${Cookies.get('memberId')}/credit-card`, setting)
    )

    getCouponList = async (status, page, perPage) => (
        this.callBackendApi('GET', `${orderAPIUrl}/${Cookies.get('memberId')}/coupons?${queryString.stringify({ page, perPage, status })}`)
    )

    getCouponProcess = async (page, perPage) => (
        this.callBackendApi('GET', `${orderAPIUrl}/${Cookies.get('memberId')}/coupons/process?${queryString.stringify({ page, perPage })}`)
    )

    updateMemberWine = async (memberWineId, quantity, cost, currency, note) => {
        let actionDate = `${new Date().toISOString().substring(0, 10)} ${new Date().toISOString().substring(11, 19)}`
        return this.callBackendApi('PATCH', `${wineAPIUrl}/${Cookies.get('memberId')}/wines/${memberWineId}`, { action: "edit", unitCostRaw: cost, currencyRaw: currency, actionDate, note, quantity })
    }

    updateCwWineNote = async (wineId, comment) => (
        this.callBackendApi('PUT', `${wineAPIUrl}/${Cookies.get('memberId')}/wines/${wineId}/tastings`, { comment })
    )

    getOrderTxnList = async (orderId) => (
        this.callBackendApi('GET', `${orderAPIUrl}/${Cookies.get('memberId')}/orders/${orderId}/transactions`)
    )

    updateOrder = async (orderId, data) => (
        this.callBackendApi('PATCH', `${orderAPIUrl}/${Cookies.get('memberId')}/orders/${orderId}`, data)
    )

    getCurrencyList = async () => (
        this.callBackendApi('GET', '/constants/currencies')
    )

    getFeeConstant = async () => (
        this.callBackendApi('GET', `storage/constants/fee`)
    )

    // reservation: {
    // 	"quantity": 10,
    // 	"referral": "mario",
    // 	"storePeriod": "半年至一年",  // 1個月 / 2個月 / 3個月 / 4個月 / 5個月 / 半年 / 半年至一年 / 一年以上 / 不確定
    // 	"isTrade": false,
    // 	"deliveryType": "personally", // personally: 親送 / logistics: 宅配
    // 	"arrivedDate": "2019-07-15",
    // 	"arrivedTime": "forenoon"  // forenoon: 上午 / afternoon: 下午
    // }
    createReservation = async (reservation) => (
        this.callBackendApi('POST', `${orderAPIUrl}/${Cookies.get('memberId')}/reservation`, reservation)
    )
}